import React, { useState, useEffect } from "react";
import styles from "./Menu.module.less";
import Button from "../Button/Button";
import buttonStyles from "../Button/Button.module.less";
import { getChapters, Chapter } from "../../api/cocApi";
import { Link } from "react-router-dom";
import useCollapse from "react-collapsed";

export default function Menu(props: { className?: string; isOpen?: boolean; onClose?: () => void }) {
    const [chapters, setChapters] = useState<Chapter[]>([]);

    useEffect(() => {
        getChapters().then(c => setChapters(c));
    }, []);

    return (
        <div className={[styles.Menu, props.isOpen ? styles["Menu--open"] : null, props.className].join(" ")}>
            <Link to="/" onClick={props.onClose}>
                <img src={process.env.PUBLIC_URL + "/assets/Business_Sweden_logo_white.svg"} alt="Logo" height="60" />
            </Link>

            <div className={styles["Menu-chapters"]}>
                {chapters.map((chapter, index) => (
                    <div className={styles["Menu-chapter"]} key={chapter.heading}>
                        <MenuChapter chapter={chapter} index={index} />
                    </div>
                ))}
            </div>

            <div className={styles["Menu-navLinks"]}>
                <Button to="/speak-up" onClick={props.onClose}>
                    Speak up
                </Button>

                <ul className="u-marginT2">
                    <li>
                        <Link className={styles["Menu-link"]} onClick={props.onClose} to="/responsibilities">
                            Responsibilities
                        </Link>
                    </li>
                    <li>
                        <Link className={styles["Menu-link"]} onClick={props.onClose} to="/word-from-our-ceo">
                            A word from our CEO
                        </Link>
                    </li>
                    <li>
                        <Link className={styles["Menu-link"]} onClick={props.onClose} to="/contact">
                            Contact
                        </Link>
                    </li>
                    <li>
                        <Link className={styles["Menu-link"]} onClick={props.onClose} to="/declaration">
                            Declaration
                        </Link>
                    </li>
                    <li>
                        <a
                            href="/code-of-conduct/assets/Business_Sweden_Code_of_Conduct_passport_210922.pdf"
                            className={styles["Menu-link"]}
                            download
                        >
                            Download PDF version
                        </a>
                    </li>
                </ul>
            </div>
            <div>
                <p> 
                    <a
                        className={[buttonStyles.Button, buttonStyles["Button--small"]].join(" ")}
                        href="https://business-sweden.com"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Go to business-sweden.com
                    </a>
                </p>
                <p className={styles["Menu-copyright"]}>© Business Sweden. All Rights Reserved</p>
            </div>
        </div>
    );
}

function MenuChapter({ chapter, index }: { chapter: Chapter; index: number }) {
    const [isOpen, setOpen] = useState(false);
    const { getCollapseProps, getToggleProps } = useCollapse({ isOpen });

    return (
        <>
            <button
                className={[styles["Menu-chapterLink"], isOpen ? styles["Menu-chapterLink--open"] : null].join(" ")}
                {...getToggleProps({
                    onClick: () => setOpen(oldOpen => !oldOpen)
                })}
            >
                <span className={styles["Menu-label"]}>Chapter {index + 1}</span>
                <span className={styles["Menu-chapterLinkInner"]}>{chapter.heading}</span>
            </button>

            <ul className={styles["Menu-chapterLinks"]} {...getCollapseProps()}>
                {chapter.items.map(article => (
                    <li key={article.heading}>
                        <Link className={styles["Menu-chapterArticleLink"]} to={article.link}>
                            {article.heading}
                        </Link>
                    </li>
                ))}
            </ul>
        </>
    );
}
